import { Suspense, lazy, type ReactNode } from "react";
import { Loader2 } from "lucide-react";
import { useAuth } from "./AuthProvider";

const LoginPage = lazy(() => import("./LoginPage").then((m) => ({ default: m.LoginPage })));

export function AuthGate({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" aria-label="Loading" />
      </div>
    );
  }

  if (!user) {
    return (
      <Suspense
        fallback={
          <div className="flex min-h-screen items-center justify-center">
            <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" aria-label="Loading" />
          </div>
        }
      >
        <LoginPage />
      </Suspense>
    );
  }

  return <>{children}</>;
}
